import { Component } from "react";
import { Table } from "semantic-ui-react";
import { Title } from "../../../../components/listViewTemplates";
import { type ColumnOptions } from "../../../../interfaces";
import { type AddOn } from "../../types";
import AddOnIcon from "./AddOnIcon/AddOnIcon";
import { TextTruncate } from "components";
import { Tooltip } from "components/common/tooltip";
import styles from "./addOnRow.module.scss";

export interface AddOnRowProps {
  addOn: AddOn;
  renderEnabledCell(addOn: AddOn): React.ReactElement;
  renderExpirationDateCell(addOn: AddOn): React.ReactElement;
}

class AddOnRow extends Component<AddOnRowProps> {
  static columnOptions: ColumnOptions[] = [
    {
      name: "Title",
      width: 5,
      className: styles.addonHeader,
    },
    {
      name: "Description",
      width: 9,
    },
    {
      name: "Enabled",
      width: 4,
      className: styles.alignedAddonHeader,
    },
    {
      name: "Expiration date",
      width: 4,
    },
  ];

  render() {
    const { addOn, renderEnabledCell, renderExpirationDateCell } = this.props;

    return (
      <>
        <Table.Cell width={AddOnRow.columnOptions[0].width} collapsing>
          <div className={styles.icon}>
            <AddOnIcon id={addOn.id} />
          </div>
          <Tooltip
            target={
              <TextTruncate>
                <Title title={addOn.name} />
              </TextTruncate>
            }
            content={addOn.name}
          />
        </Table.Cell>
        <Table.Cell width={AddOnRow.columnOptions[1].width}>{addOn.description}</Table.Cell>
        <Table.Cell width={AddOnRow.columnOptions[2].width} collapsing className={styles.enabledAddons}>
          {renderEnabledCell(addOn)}
        </Table.Cell>
        <Table.Cell width={AddOnRow.columnOptions[3].width}>{renderExpirationDateCell(addOn)}</Table.Cell>
      </>
    );
  }
}

export default AddOnRow;
